import { __rest } from "tslib";
import * as React from 'react';
import { forwardRef } from 'react';
import PhoneInputComponent from 'react-phone-number-input';
const { formatPhoneNumberIntl } = require('react-phone-number-input');
import Input from '../Input/Input';
import { useTheme } from '../theme';
import cn from 'classnames';
import { normalizePhoneNumber } from './utils';
const Context = React.createContext({});
const InputWrapper = forwardRef((_a, ref) => {
    var _b;
    var { onFocus, onKeyDown } = _a, props = __rest(_a, ["onFocus", "onKeyDown"]);
    const onChange = (e) => {
        props.onChange(normalizePhoneNumber(e.target.value));
    };
    const parsedPhone = formatPhoneNumberIntl(props.value) || formatPhoneNumberIntl(`+${props.value}`);
    const textFieldsProps = React.useContext(Context);
    const _c = (_b = textFieldsProps === null || textFieldsProps === void 0 ? void 0 : textFieldsProps.InputProps) !== null && _b !== void 0 ? _b : {}, { value } = _c, InputProps = __rest(_c, ["value"]);
    const css = useTheme('PhoneInput').PhoneInput;
    if (props.renderInput) {
        return props.renderInput({
            absoluteHintPosition: true,
            className: cn(css.input, props.className),
            inputClassName: textFieldsProps.className,
            variant: textFieldsProps.variant,
            TextFieldProps: {
                onFocus,
                onKeyDown,
                onChange,
                // Do not spread `context.textFieldsProps` there,
                // or `react-phone-number-input` won't work.
                name: textFieldsProps.name,
                onBlur: textFieldsProps.onBlur,
                label: textFieldsProps.label,
                error: textFieldsProps.error,
                helperText: textFieldsProps.helperText,
                disabled: textFieldsProps.disabled || props.disabled,
                placeholder: textFieldsProps.placeholder,
                type: 'tel',
                InputProps,
                className: textFieldsProps.className,
                InputLabelProps: textFieldsProps.InputLabelProps
            },
            disabled: props.disabled,
            value: parsedPhone ? parsedPhone : props.value,
            tabIndex: textFieldsProps.tabIndex,
            inputMode: 'tel',
            autoFocus: props.autoFocus
        });
    }
    return (React.createElement(Input, { absoluteHintPosition: true, className: cn(css.input, props.className), inputClassName: textFieldsProps.className, variant: textFieldsProps.variant, TextFieldProps: {
            onFocus,
            onKeyDown,
            onChange,
            // Do not spread `context.textFieldsProps` there,
            // or `react-phone-number-input` won't work.
            name: textFieldsProps.name,
            onBlur: textFieldsProps.onBlur,
            label: textFieldsProps.label,
            error: textFieldsProps.error,
            helperText: textFieldsProps.helperText,
            disabled: textFieldsProps.disabled || props.disabled,
            placeholder: textFieldsProps.placeholder,
            type: 'tel',
            InputProps,
            className: textFieldsProps.className,
            InputLabelProps: textFieldsProps.InputLabelProps
        }, disabled: props.disabled, value: parsedPhone ? parsedPhone : props.value, tabIndex: textFieldsProps.tabIndex, inputMode: "tel", autoFocus: props.autoFocus }));
});
const PhoneInput = ({ className, value, textFieldsProps = {}, displayInitialValueAsLocalNumber = true, disabled, autoFocus, renderInput }) => {
    return (React.createElement(Context.Provider, { value: textFieldsProps },
        React.createElement(PhoneInputComponent, { className: className, onChange: textFieldsProps.onChange, onFocus: textFieldsProps.onFocus, onBlur: textFieldsProps.onBlur, showCountrySelect: false, limitMaxLength: true, displayInitialValueAsLocalNumber: displayInitialValueAsLocalNumber, value: value || '', inputComponent: InputWrapper, disabled: disabled, autoFocus: autoFocus, renderInput: renderInput })));
};
export default PhoneInput;
